module.exports = __webpack_public_path__ + "static/media/ma.c422104c.jpeg";